import { HTMLCustomElement } from '@theme/html-custom-element';
import { Splide } from '@theme/splide';

class ProductGallery extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    new Splide(this.refs.slider, {
      arrows: false,
      loop: true,
      type: 'loop',
      autoplay: true,
      interval: 4000,
    }).mount();
  }
}

if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
